import { createContext } from 'react';
import { Access, UserContextValue } from '../types';

export const initialValue: UserContextValue = {
  access: Access.loading,
};

export const UserContext = createContext<UserContextValue>(initialValue);
